import useIframe from "utils/useIframe"
import styles from "./ServiceIframe.module.scss";
import React, { useEffect, useState } from "react";
import externals from "utils/externals";
import useCurrentService from "utils/useCurrentService";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, Redirect, Switch, Route } from "react-router-dom";
import { MainLoader } from "ui-components-rollup/dist/Loaders";
import { TabHeader, TabLinks } from "ui-components-rollup/dist/Tabs";
import classNames from "classnames";
import _ from "lodash";
import DefaultRoute from "modules/app/components/DefaultRoute";

const ShowIframe = ({ currentService, subTab, isThirdParty, isWizardOpen = false, setWizardOpen = _.noop }) => {
    //const {isInitialized, iframeRef, src} = useIframe({iframeUrl: externals.serviceIframes[currentService.key]})
    const iframeKey = subTab ? subTab.iframeKey || subTab.key : currentService.key;
    const trackKey = subTab ? `${currentService.key}.${subTab.key}` : currentService.key;
    const { iframeRef, src } = useIframe({ iframeUrl: externals.serviceIframes[iframeKey], isThirdParty, trackKey, setWizardOpen })

    useEffect(() => {
        return () => {
            setWizardOpen(false);
        }
    }, [setWizardOpen]);

    if (!externals.serviceIframes[iframeKey]) {
        return <div>
            Invalid Configuration -> No Path for {iframeKey}
        </div>
    }

    return <>
        {/*{<MainLoader/>}*/}
        <iframe title="service" src={src} ref={iframeRef} className={classNames(styles['base'], { [styles['sub-tab']]: subTab && !isWizardOpen })}/>
    </>
};

export const RenderSubIframe = ({ subTab, currentService, isWizardOpen, setWizardOpen }) => {
    return <DefaultRoute subService={subTab}><ShowIframe currentService={currentService} isThirdParty={false} subTab={subTab} isWizardOpen={isWizardOpen} setWizardOpen={setWizardOpen}/></DefaultRoute>
}

const ParentService = React.memo(({ currentService }) => {
    const [isWizardOpen, setWizardOpen] = useState(false);
    const activeFeatures = useSelector(state => state.features.active);

    const filteredServices = currentService.service.subServices.filter(subService => {
        return activeFeatures[`${currentService.key}.${subService.key}`];
    });

    return <>
        {!isWizardOpen && <TabHeader logo={currentService.logo} label={currentService.service.label}>
            <TabLinks>
                {filteredServices.map(({ to, label }) => {
                    return <NavLink key={label} exact to={`${currentService.service.to}${to}`}>{label}</NavLink>
                })}
            </TabLinks>
        </TabHeader>}
        <Switch>
            {filteredServices.map((subTab) => {
                return <Route path={`${currentService.service.to}${subTab.to}`} key={subTab.label}>
                    <RenderSubIframe subTab={subTab} currentService={currentService} isWizardOpen={isWizardOpen} setWizardOpen={setWizardOpen}/>
                </Route>
            })}
            <Redirect to={`${currentService.service.to}${currentService.service.subServices[0].to}`}/>
        </Switch>
    </>
})

export default React.memo(() => {
    const currentService = useCurrentService();
    const isThirdParty = currentService.service.isThirdParty;
    const dispatch = useDispatch();
    const selectedAgentId = useSelector(state => state.tenancy.selectedAgentId);
    const openAddConnector = currentService.service.needsConnector && !selectedAgentId;
    const { thirdPartyToken } = useSelector(state => state.auth);

    useEffect(() => {
        if (isThirdParty) {
            dispatch({
                type: "AUTH:THIRD-PARTY-AUDIENCE"
            })
        }
    }, [isThirdParty, dispatch])

    if (openAddConnector) {
        return <Redirect to={{ pathname: window.location.pathname, hash: "#addConnector" }}/>;
    } else if (isThirdParty && !thirdPartyToken) {
        return <MainLoader/>
    } else if (currentService.service.isParent) {
        return <ParentService key={currentService.key} currentService={currentService}/>
    } else {
        return <DefaultRoute><ShowIframe key={currentService.key} currentService={currentService} isThirdParty={isThirdParty}/></DefaultRoute>
    }
})
